import JobDetail4Container from "../../../components/job/detail/JobDetail4";

const JobDetail4 = () => {
  return <JobDetail4Container />;
};

export default JobDetail4;
